import { createContext } from "react";

export const ShowNavbarContext = createContext({
  visible: true,
  setVisible: (_val: boolean) => {},
});
